import { useStore } from "zustand";
import { useDashboardName } from "../../store/headerName";
import { useEffect, useState } from "react";
import { Table } from "antd";
import BaseCard from "../../components/card/BaseCard";
import { Icon } from "@iconify/react";
import BaseTable from "../../components/BaseTable";
import type { TableProps } from "antd/lib";
import ButtonIcon from "../../components/ButtonIcon";
import ConfirmModal from "../../components/modal/ConfirmModal";
import { Link } from "react-router";
import {
  GetFullMediaPath,
  numberFormatter,
  numberFormatterLabel,
} from "../../helper/method";
import StatusVisit from "../../components/StatusVisit";
import { $api, type components } from "../../helper";
import ButtonLinkIcon from "../../components/ButtonLinkIcon";
import { statusMock, tokenMock } from "../../helper/mock";
import { useNotify } from "../../helper/notify";
import FilterSearch from "../../components/filter/FilterSearch";
import ButtonIconSvg from "../../components/ButtonIconSvg";
import Trash from "../../components/svg/Trash";
import ButtonLinkIconSvg from "../../components/ButtonLinkIconSvg";
import PenSquare from "../../components/svg/PenSquare";

export default function ProductList() {
  const [isOpen, setIsOpen] = useState(false);
  const notify = useNotify();
  const { setDashboardName } = useStore(useDashboardName);
  const [id, setId] = useState("");
  const { data, isLoading, refetch } = $api.useQuery(
    "get",
    "/site-api/v1/product/",
  );
  const { mutate, isPending } = $api.useMutation(
    "delete",
    "/site-api/v1/product/",
  );
  useEffect(() => {
    setDashboardName("لیست محصولات");
  }, []);

  const columns: TableProps<
    components["schemas"]["SiteProductItem"]
  >["columns"] = [
    {
      title: "#",
      dataIndex: "key",
      key: "key",
      render: (_, record, index) => <span>{index + 1}</span>,
    },
    {
      title: "تصویر محصول",
      dataIndex: "image",
      key: "image",
      render: (_, record) => (
        <div className="aspect-square w-16 rounded-lg overflow-hidden">
          <img
            src={GetFullMediaPath(record.image)}
            alt=""
            className="w-full h-full object-cover"
          />
        </div>
      ),
    },
    {
      title: "عنوان محصول",
      dataIndex: "title",
      key: "title",
      filterDropdown: ({
        setSelectedKeys,
        selectedKeys,
        confirm,
        clearFilters,
      }) => (
        <FilterSearch
          clearFilters={clearFilters}
          confirm={confirm}
          selectedKeys={selectedKeys}
          setSelectedKeys={setSelectedKeys}
        />
      ),
      onFilter: (value, record) =>
        record?.title
          ?.toLowerCase()
          ?.includes(value.toString().toLocaleLowerCase()),
      filterIcon: () => (
        <Icon className="text-xl" icon={"solar:magnifer-linear"} />
      ),
    },
    {
      title: "قیمت محصول",
      dataIndex: "price",
      key: "price",
      render: (_, record) => <span>{numberFormatterLabel(record.price)}</span>,
    },
    {
      title: "قیمت با تخفیف",
      dataIndex: "off_price",
      key: "off_price",
      render: (_, record) => (
        <span>{numberFormatterLabel(record.price_with_discount ?? 0)}</span>
      ),
    },
    {
      title: "دسته بندی",
      key: "category",
      dataIndex: "category",
      filters: data?.data?.map((e) => ({
        text: e.category,
        value: e.u_id,
      })),
      onFilter: (value, record) => record.u_id.indexOf(value as string) === 0,
    },
    {
      title: "موجودی",
      dataIndex: "stock",
      key: "stock",
      render: (_, record) => <span>{numberFormatter(record.stock)}</span>,
    },
    {
      title: "نمایش در سایت",
      key: "show",
      dataIndex: "show",
      filters: statusMock,
      onFilter: (value, record) =>
        record.status.toString().indexOf(value as string) === 0,
      render: (_, record) => <StatusVisit status={record.status} />,
    },
    {
      title: "عملیات",
      key: "action",
      render: (_, record) => (
        <div className="flex">
          {/* <ButtonLinkIcon
            to={{
              pathname: "/product-list/add-product",
              search: `?u_id=${record.u_id}`,
            }}
            icon="solar:pen-new-square-linear"
            className="text-primary-500!"
          /> */}
          <ButtonLinkIconSvg
            icon={<PenSquare />}
            to={{
              pathname: "/product-list/add-product",
              search: `?u_id=${record.u_id}`,
            }}
            className="text-primary-500!"
          />
          {/* <ButtonIcon
            icon="solar:trash-bin-trash-linear"
            className="text-error-500!"
            onClick={() => {
              setId(record.u_id);
              setIsOpen(true);
            }}
          /> */}
          <ButtonIconSvg
            icon={<Trash />}
            className="text-error-500!"
            onClick={() => {
              setId(record.u_id);
              setIsOpen(true);
            }}
          />
        </div>
      ),
    },
  ];

  return (
    <div className="grid grid-cols-12 gap-6">
      {/* modal */}
      <ConfirmModal
        pending={isPending}
        title="حذف از محصولات ؟"
        description="حذف این محصول باعث عدم نمایش آن در بخش‌های مرتبط می‌شود."
        action={() => {
          mutate(
            {
              params: {
                query: {
                  product_u_id: id,
                },
              },
              headers: {
                Authorization: tokenMock,
                lang: "fa",
              },
            },
            {
              onSuccess: (data) => {
                notify.success(data.message);
                setId("");
                setIsOpen(false);
                refetch();
              },
            },
          );
        }}
        open={isOpen}
        onClose={() => {
          setId("");
          setIsOpen(false);
        }}
      />
      <div className="w-full flex justify-end col-span-full sm:flex-row sm:gap-0 gap-4 flex-col sm:items-center items-start">
        <Link to={"/product-list/add-product"} className="button-style">
          افزودن محصول
        </Link>
      </div>

      <div className="w-full flex-1 col-span-full">
        <BaseCard props={{ className: "flex-1 flex-col flex gap-6" }}>
          <BaseTable
            props={{
              className: "min-w-0!",
            }}
          >
            <Table<components["schemas"]["SiteProductItem"]>
              scroll={{
                x: "max-content",
              }}
              loading={isLoading}
              columns={columns}
              dataSource={data?.data}
            />
          </BaseTable>
        </BaseCard>
      </div>
    </div>
  );
}
